import React from 'react';
import Style from './index.module.scss';
import {Tag} from 'antd';
import {ArticleList} from '../../service';
import {formatDate} from '../../../../../Utils/common';
import {isEmpty} from '../../../../../Stores/commonStore';

interface Props {
    data: ArticleList;
    action?: React.ReactNode;
}
const Index = ({action, data}: Props) => {
    return (
        <div className={Style.main}>
            <div className={Style.middle}>
                <div className={Style.title}>
                    <a href={data.link} target="_blank">
                        <span className={Style.name}>{data.title}</span>
                    </a>
                </div>
                <ul className={Style.ul}>
                    {!isEmpty(data.digest) && (
                        <li>
                            <span className={Style.label}>摘要：</span>
                            {data.digest}
                        </li>
                    )}
                    {!isEmpty(data.officialAccountName) && (
                        <li>
                            <span className={Style.label}>来源：</span>
                            {data.officialAccountName}
                        </li>
                    )}
                    {!isEmpty(data.publishDate) && (
                        <li>
                            <span className={Style.label}>时间：</span>
                            {formatDate(
                                data.publishDate,
                                'YYYY-MM-DD hh:mm:ss',
                            )}
                        </li>
                    )}
                    {!isEmpty(data?.tags) && (
                        <li>
                            {data?.tags?.map(item => {
                                return (
                                    <Tag key={item.content} color={item.color}>
                                        {item.content}
                                    </Tag>
                                );
                            })}
                        </li>
                    )}
                </ul>
            </div>
            <div className={Style.action}>{action}</div>
        </div>
    );
};

export default Index;
